import { render, staticRenderFns } from "./EmployeeDepts.vue?vue&type=template&id=0ba1af50&scoped=true"
import script from "./EmployeeDepts.vue?vue&type=script&lang=js"
export * from "./EmployeeDepts.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDepts.vue?vue&type=style&index=0&id=0ba1af50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1af50",
  null
  
)

export default component.exports